module.exports = __webpack_public_path__ + "img/test3.e279ad76.png";